import { Link } from 'react-router-dom'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import AddWorkedHoursHint from 'modules/project_management/components/hints/myProjects/AddWorkedHoursHint'

interface IEmptyTableMessageProps {
  addProject: () => void
  canRegisterFlexibleTracking: boolean
}

const EmptyTableMessage = ({
  addProject,
  canRegisterFlexibleTracking,
}: IEmptyTableMessageProps) => {
  const descriptionStyle = {
    paddingLeft: '11vw',
    paddingRight: '11vw',
  }

  return (
    <Box
      textAlign="center"
      style={descriptionStyle}
      flexDirection="column"
      gap="s8"
      alignItems="center"
    >
      <Box paddingBottom="s8">
        <Icon.Large icon="tracking-timer" color="grey600" />
      </Box>
      <Text weight="medium" size="400" color="grey1000">
        {i18n.t('project_management.my_projects.table.empty_table_message.title')}
      </Text>
      <Text weight="normal" size="300" color="grey800">
        {i18n.t('project_management.my_projects.table.empty_table_message.description')}
        <Link
          to="https://help.factorialhr.com/recruitment-organization#tasks-projects"
          target="_blank"
        >
          <Text size="300" color="radicalRed1000">
            {i18n.t('project_management.my_projects.table.empty_table_message.here')}
          </Text>
        </Link>
      </Text>
      {canRegisterFlexibleTracking && (
        <Box paddingTop="s12">
          <Button type="secondary" onClick={addProject} iconName="add">
            {i18n.t('project_management.my_projects.table.empty_table_message.add_button')}
          </Button>
        </Box>
      )}
      <Box textAlign="left" paddingRight="s64">
        <AddWorkedHoursHint stepNumber={2} />
      </Box>
    </Box>
  )
}

export default EmptyTableMessage
